export default __webpack_public_path__ + "static/media/grey-ripplr.5c7f9a22.svg";